import { dataHooks } from '@wix/data-hooks'

export const wixStudioVeloDataHooks = dataHooks<{
  title: {}
  subtitle: {}
  item: { key: string }
}>('wix-studio-velo')
